export function isNullOrWhitespace(input: string | undefined) {
    if (typeof input === "undefined" || input === null) return true;
    return input.replace(/\s/g, "").length < 1;
}

export function htmlEncode(str: string) {
    var div = document.createElement("div");
    var text = document.createTextNode(str);
    div.appendChild(text);
    return div.innerHTML;
}
export function IsEmailAddress(str: string): boolean {
    //Check if string contain @ sign
    if (str.indexOf("@") < 0) return false;
    //Check for more than 1 @ sign
    var firstoccurrenceATsign = str.indexOf("@");
    var NextoccurrenceATSign = str.lastIndexOf("@");
    if (firstoccurrenceATsign != NextoccurrenceATSign && NextoccurrenceATSign > -1) return false;
    //Check if @ sign is the 1st character
    if (firstoccurrenceATsign == 0) return false;
    //Check if @ sign is the last character
    if (firstoccurrenceATsign == str.length - 1) return false;

    return true;
}

/**
 * Split a delimited string into substrings using the comma, space, semicolon or space separators and return them as an array.
 * @param mixedDelStr The string with combined delimeters i.e. '"," or " " or ";" or any combination with the space'
 * @returns list of substrings spplit by the common delimiters
 * @example splitByAll("Alic, Bob;Charl, Dolly Erik ,Frank,,"); // should return ["Alic", "Bob", "Charl", "Dolly", "Erik" , "Frank"]
 */
export function splitByAll(mixedDelStr: string): string[] {
    const subs: string[] = mixedDelStr.split(/[ ,]+|[ ;]+|[ ]/);
    return subs.filter(s => s.length > 0);
}

const SPACER_TAGS = ["BR", "SPAN", "O:P", "FONT", "B", "I", "U"];

/**
 * Remove empty Outlook/Word spacer paragraphs (<p class="MsoNormal">) and TinyMCE editor leftovers.
 * A paragraph is removed only when it has no visible text and holds nothing but <br>s and inline wrappers,
 * so paragraphs carrying content (signature lines, logos, links) are kept.
 */
export function removeEmptyMsoParagraphs(root: ParentNode) {
    // editor-only nodes, never part of the real content
    root.querySelectorAll('[data-mce-bogus="all"], span[data-mce-type="bookmark"]').forEach(el => el.remove());
    root.querySelectorAll("br[data-mce-bogus]").forEach(br => br.remove());

    root.querySelectorAll("p.MsoNormal").forEach(p => {
        //   nbsp, ​ zero-width space (Outlook), ﻿ TinyMCE caret
        const text = (p.textContent ?? "").replace(/[ ​﻿\s]/g, "");
        const hasRealElement = Array.from(p.querySelectorAll("*")).some(
            el => !SPACER_TAGS.includes(el.tagName.toUpperCase()),
        );
        if (text === "" && !hasRealElement) {
            p.remove();
        }
    });
}
